import { pipe, tap } from 'wonka'

export const traceExchange =
  (trace) =>
  ({ forward }) =>
  (operations$) => {
    return pipe(
      operations$,
      tap((op) => {
        if (trace && op.operationName === 'query') {
          trace(
            `URQL - ${op.query.definitions.find(({ kind }) => kind === 'OperationDefinition').name.value}`,
            'startRequest'
          )
        }
      }),
      forward
    )
  }

export const errorExchange =
  ({ forward }) =>
  (operations$) => {
    return pipe(
      operations$,
      forward,
      tap(({ error }) => {
        if (error) {
          const { graphQLErrors, networkError } = error
          if (graphQLErrors) {
            graphQLErrors.map(({ message, locations, path }) =>
              console.error(
                `[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(locations)}, Path: ${path}`
              )
            )
          }
          if (networkError) console.log(`[Network error]: ${networkError}`)
        }
      })
    )
  }
